<template>
  <GridBase gak-common class="gak-sejong">
    <section class="top">
      <h1>GAK<br />SEJONG</h1>
    </section>
    <section class="s1 j">
      <PrSplit class="v1" type="type0" img="/img/dc/sejong/bg-hyperscale.png">
        <div class="title">
          <h2>Tech convergence</h2>
          <h2>engine for all</h2>
        </div>
      </PrSplit>
      <TextBlock file="dc/sejong-data-t1" class="pre-line q j" data-offset="100" />
    </section>
    <section class="s2 j" data-offset="0">
      <PrHoldOrNot img="/img/dc/sejong/bg-map.jpg" title="Location" direction="" mobile-height="375">
        <template v-slot:holdRight>
          <div class="dc-sample-s2-exp" data-p="0.4,1" data-px="-100,0" data-a="0,1">
            <h3>
              This is <br />Sejong Special<br class="hidden-xxl-up" />
              Self-<br class="hidden-xxl-down" />Governing City
            </h3>
            <div class="cover">
              <h4>
                Site for <br />
                Korea's largest <br />
                Data center
              </h4>
              <h5>
                DATA CENTER GAK Sejong was designed with the priority of securing a stable power supply and
                communication network. After carefully reviewing about 10 candidate sites, city of Sejong was selected
                as the winner as it had the conditions to operate a data center with stability. The site has a power
                supply of up to 270 MW through two lines from a 154 kV substation.
              </h5>
            </div>
          </div>
        </template>

        <div class="dc-sample-s2-exp">
          <div class="img">Location</div>
          <h3 class="q">This is Sejong Special <br class="hidden-md-up" />Self-Governing City</h3>
          <div class="cover">
            <h4 class="q">
              Site for <br class="hidden-sm-down" />Korea's largest <br />
              data center
            </h4>
            <p class="q">
              DATA CENTER GAK Sejong was designed with the priority of securing a stable power supply and communication
              network. After carefully reviewing about 10 candidate sites, city of Sejong was selected as the winner as
              it had the conditions to operate a data center with stability. The site has a power supply of up to 270 MW
              through two lines from a 154 kV substation.
            </p>
          </div>
        </div>
      </PrHoldOrNot>
    </section>
    <section class="s3 energy">
      <PrBlock class="v1 j">
        <img src="/img/dc/sejong/bg-s3.jpg" alt="" />
      </PrBlock>
      <div class="exp">
        <h4>
          <TextBlock file="dc/sejong-data-t3" class="pre-line q" />
        </h4>
        <TextBlock file="dc/sejong-data-t2" class="q" />
      </div>
    </section>
    <section class="s3 arc">
      <GridBase class="c1" v-if="this.sect === 'sm' || this.sect === 'md'">
        <div class="img">
          <div class="bg"></div>
          <div class="tit">
            <h3>
              <em>ARC & ARM-System</em>
              the cloud brain of robots
            </h3>
          </div>
        </div>
        <div class="exp">
          <TextBlock file="dc/sejong-data-t4" class="pre-line q" />
        </div>
      </GridBase>
      <PrSlideOrNot
        id="arc-v1"
        img="/img/dc/sejong/bg-arc.jpg"
        title="ARC & ARM-System"
        titleSub="the cloud brain of robots"
        direction="l2r"
        v-else
        class="j"
        data-offset="0"
      >
        <template v-slot:slide>
          <TextBlock data-p="0.8,1" data-a="0,1" data-y="50,0" file="dc/sejong-data-t4" class="pre-line" />
        </template>
      </PrSlideOrNot>
    </section>
    <section class="s3 robot">
      <ul>
        <li>
          <PrBlock class="v1 j">
            <slider>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong/sero-slide-1_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong/sero-slide-1_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong/sero-slide-1_md.png" />
                <img src="/img/dc/sejong/sero-slide-1.png" alt="" />
              </picture>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong/sero-slide-2_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong/sero-slide-2_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong/sero-slide-2_md.png" />
                <img src="/img/dc/sejong/sero-slide-2.png" alt="" />
              </picture>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong/sero-slide-3_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong/sero-slide-3_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong/sero-slide-3_md.png" />
                <img src="/img/dc/sejong/sero-slide-3.png" alt="" />
              </picture>
            </slider>
          </PrBlock>
          <div class="exp">
            <h4>
              <em>SeRo,</em>
              automated asset<br />
              management robot
            </h4>
            <p class="txt">
              SeRo, an asset management automation robot SeRo is a robot developed to safely and efficiently manage
              servers, the core assets of data center IT warehouses. With a precise 2-5mm control, it can safely load
              and unload assets without human intervention and collaborate with the autonomous transportation robot
              GaRo.
            </p>
          </div>
        </li>
        <li class="small">
          <PrBlock class="v1 j">
            <slider>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong//garo-slide-1_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong//garo-slide-1_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong//garo-slide-1_md.png" />
                <img src="/img/dc/sejong/garo-slide-1.png" alt="" />
              </picture>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong//garo-slide-2_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong//garo-slide-2_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong//garo-slide-2_md.png" />
                <img src="/img/dc/sejong/garo-slide-2.png" alt="" />
              </picture>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong//garo-slide-3_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong//garo-slide-3_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong//garo-slide-3_md.png" />
                <img src="/img/dc/sejong/garo-slide-3.png" alt="" />
              </picture>
            </slider>
          </PrBlock>
          <div class="exp">
            <h4>
              <em>GaRo,</em>
              autonomous <br />
              transportation robot
            </h4>
            <p class="txt">
              GaRo is a robot that transports heavy servers and assets throughout the data center. It can carry up to
              400kg of assets and move between warehouses and server rooms, efficiently receiving and shipping assets
              with the asset management automation robot SeRo.
            </p>
          </div>
        </li>
        <li class="small">
          <PrBlock class="v1 j">
            <picture>
              <source media="(min-width: 1600px)" srcset="/img/dc/sejong//robostation-slide-1_pc.png" />
              <source media="(min-width: 1024px)" srcset="/img/dc/sejong//robostation-slide-1_lg.png" />
              <source media="(min-width: 768px)" srcset="/img/dc/sejong//robostation-slide-1_md.png" />
              <img src="/img/dc/sejong/robostation-slide-1.png" alt="" />
            </picture>
          </PrBlock>
          <div class="exp">
            <h4><em>ROBOSTATION</em></h4>
            <p class="txt">
              ROBOSTATION, a human-robot collaboration desk ROBOSTATION is a workstation that allows humans and robots
              to collaborate safely in the data center's IT warehouse. Since relying solely on robots to move assets in
              and out of the warehouse can make responding efficiently to unexpected situations difficult, we've
              installed the interfacing facility to allow safe collaboration between human workers and the asset
              management automation robot SeRo.
            </p>
          </div>
        </li>
        <li>
          <PrBlock class="v1 j">
            <slider>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong//alt-b-slide-1_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong//alt-b-slide-1_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong//alt-b-slide-1_md.png" />
                <img src="/img/dc/sejong/alt-b-slide-1.png" alt="" />
              </picture>
              <picture>
                <source media="(min-width: 1600px)" srcset="/img/dc/sejong//alt-b-slide-2_pc.png" />
                <source media="(min-width: 1024px)" srcset="/img/dc/sejong//alt-b-slide-2_lg.png" />
                <source media="(min-width: 768px)" srcset="/img/dc/sejong//alt-b-slide-2_md.png" />
                <img src="/img/dc/sejong/alt-b-slide-2.png" alt="" />
              </picture>
            </slider>
          </PrBlock>
          <div class="exp">
            <h4>
              <em>ALT-B,</em>
              autonomous shuttle
            </h4>
            <p class="txt">
              ALT-B is an unmanned autonomous shuttle that operates in the data center. It helps workers move
              comfortably and safely around the vast GAK Sejong campus, which is the size of 41 soccer fields and has a
              round-trip distance of more than 1 kilometer. It is equipped with NAVER's own full-stack autonomous
              driving technology and is controlled by the ARC system based on NAVER Cloud.
            </p>
          </div>
        </li>
      </ul>
    </section>
    <section class="s6 technology">
      <PrSplit class="v1 q" type="type1" img="/img/dc/sejong/bg-technology.jpg" title="Technology" />
      <div class="exp">
        <h4 class="q">
          Concentration<br class="hidden-md-down" />
          of <br class="hidden-lg-up" />cutting-edge<br class="hidden-md-down" />
          technologies
        </h4>
        <p class="q">
          DATA CENTER GAK Sejong is pioneering a new era as a hyperscale data center that can stably operate NAVER's
          various future services and technologies, including hyperscale AI, cloud services, digital twins, and robots.
        </p>
      </div>
      <quick-link-item type="gray">
        <a class="" href="/tech/technology">See in Technology</a>
      </quick-link-item>
    </section>
    <section class="s4 architecture">
      <PrSplit class="v4" img="/img/dc/sejong/bg-architecture.jpg" title="Architecture" />

      <div class="exp">
        <h3>
          Designs that embrace<br />
          high-tech and nature
        </h3>
        <video :src="`${videoBase}/sejong.mp4`" muted autoplay loop playsinline class="pic" />
        <h4 class="q">
          Server room<br class="hidden-sm-down" />
          meets the<br class="hidden-sm-down" />
          natural wind
        </h4>
        <p class="q">
          DATA CENTER GAK Sejong is designed with the optimal layout and shape to maximize energy efficiency without
          interfering with the flow of nature.
        </p>
      </div>
    </section>
    <section class="s5 building">
      <PrHoldOrNot
        id="building-v1"
        img="/img/dc/sejong/bg-building.jpg"
        :html="buildingT1"
        text="DATA CENTER GAK Sejong built using materials and components using construction methods that minimize artificial processing to reduce damage to the environment. The building was constructed by actively utilizing eco-friendly materials and approaches, such as exposing concrete as is and using aluminum without artificial processing as the main material."
        direction="b2t"
        position="right"
        mobile-height="375"
      >
        <template v-slot:holdBottom>
          <div id="building-t2" class="dc-sample-s2-exp" data-p="0.4,1" data-a="0,1" data-py="50,0">
            <div class="cover">
              <h3 class="q">From a single rack to<br />a huge server wing</h3>
              <p class="q">
                It has a structure that allows flexible expansions and operation of massive amounts of data, increasing
                due to rapid technological growth and service changes, through several racks, zones, and server wings.
              </p>
            </div>
          </div>
        </template>
        <div class="dc-sample-s2-exp">
          <div class="img">
            <div class="exp">
              <h3 class="q">Nature-like<br class="hidden-md-down" />buildings</h3>
              <p class="q">
                DATA CENTER GAK Sejong built using materials and components using construction methods that minimize
                artificial processing to reduce damage to the environment. The building was constructed by actively
                utilizing eco-friendly materials and approaches, such as exposing concrete as is and using aluminum
                without artificial processing as the main material.
              </p>
            </div>
          </div>
          <div class="cover">
            <h3 class="q">From a single rack to<br />a huge server wing</h3>
            <p class="q">
              It has a structure that allows flexible expansions and operation of massive amounts of data, increasing
              due to rapid technological growth and service changes, through several racks, zones, and server wings.
            </p>
          </div>
        </div>
      </PrHoldOrNot>
    </section>
    <section class="s5 main-building">
      <PrSplit class="v5" type="type2" img="/img/dc/sejong/bg-main-building.jpg" />
      <div class="exp">
        <h4 class="q">
          Back-to-basics<br class="hidden-lg-up hidden-sm-down" />
          main building
        </h4>
        <p class="q">
          The main building, where its IT infrastructure facilities are managed to run reliably around the clock, was
          designed with mobility efficiency for workers as the top priority.<br />
          To enable swift performance of necessary tasks in a hyperscale data center,<br class="hidden-md-down" />
          underground passages and above-ground bridges are built that allow quick access to the server wings.
        </p>
      </div>
    </section>
    <div class="feature j">
      <section class="s4 gallery">
        <PrSplit class="v4" img="/img/dc/sejong/bg-gallery.png" title="GAK SEJONG Gallery" overflowTitle="" />
      </section>
      <SliderTumbs navigation="true">
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-23.png" />
          </div>
          <div class="txt">
            <p>GAK Sejong, NAVER's second data center built on a site the size of 41 soccer fields</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-22.png" />
          </div>
          <div class="txt">
            <p>
              Server wing (north building) built with a structure that allows for step-by-step expansion according to
              service scale
            </p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-1.png" />
          </div>
          <div class="txt">
            <p>GAK Sejong, NAVER's second data center built on a site the size of 41 soccer fields</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-24.png" />
          </div>
          <div class="txt">
            <p>
              Gak Sejong from the main entrance, connecting to the main building and the server wing (north building).
            </p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-2.png" />
          </div>
          <div class="txt">
            <p>
              Server wing (north building) built with a structure that allows for step-by-step expansion according to
              service scale
            </p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-25.png" />
          </div>
          <div class="txt">
            <p>
              Server wing (north building) built with a structure that allows for step-by-step expansion according to
              service scale, connected to the main building via a bridge
            </p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-26.png" />
          </div>
          <div class="txt">
            <p>
              Server wing (north building) built with a structure that allows for step-by-step expansion according to
              service scale, connected to the main building via a bridge
            </p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-3.jpg" />
          </div>
          <div class="txt">
            <p>
              Aluminum panels installed to increase cooling efficiency with a curved shape that minimizes light
              reflection
            </p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-4.png" />
          </div>
          <div class="txt">
            <p>The main building where each operation-related space of GAK Sejong is located</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-5.jpg" />
          </div>
          <div class="txt">
            <p>
              A bridge connecting the main building and the server building (north wing) to enable quick response in
              case of an issue
            </p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-6.jpg" />
          </div>
          <div class="txt">
            <p>ALT-B, the driverless and autonomous shuttle that helps workers navigate safely and comfortably</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-7.jpg" />
          </div>
          <div class="txt">
            <p>IT robot warehouse where the robot automation system is applied for efficient data center operation</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-8.jpg" />
          </div>
          <div class="txt">
            <p>SeRo, the automated asset management robot that improves work efficiency</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-9.jpg" />
          </div>
          <div class="txt">
            <p>Garo, an autonomous transportation robot that can move heavy equipment</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-10.jpg" />
          </div>
          <div class="txt">
            <p>Control center that can identify and respond to all situations in the data center at a glance</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-11.jpg" />
          </div>
          <div class="txt">
            <p>
              Server room where large-scale GPU infrastructure that becomes the base for high-performance services is
              built
            </p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-12.jpg" />
          </div>
          <div class="txt">
            <p>Cables neatly arranged and connected to the server room rack</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-13.jpg" />
          </div>
          <div class="txt">
            <p>Servers powered through server room racks</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-14.jpg" />
          </div>
          <div class="txt">
            <p>
              View of the upper part of the server room where the cat walk for inspection and wiring/piping are
              separated
            </p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-15.jpg" />
          </div>
          <div class="txt">
            <p>Fan wall that blows low-power, high-volume wind into the server room to improve energy efficiency</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-16.jpg" />
          </div>
          <div class="txt">
            <p>
              NAMU III, a hybrid air conditioning system that directly/indirectly uses natural wind to cool the server
              room
            </p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-17.jpg" />
          </div>
          <div class="txt">
            <p>
              GIS room that safely receives the ultra-high voltage electricity of 154 kV and supplies power for GAK
              Sejong
            </p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-18.jpg" />
          </div>
          <div class="txt">
            <p>UPS supplies stable power to servers even when a momentary power outage occurs</p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-19.jpg" />
          </div>
          <div class="txt">
            <p>
              Emergency generator that starts immediately in the event of a power outage and supplies power for up to 72
              hours
            </p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-20.jpg" />
          </div>
          <div class="txt">
            <p>
              Fire extinguishing gas room equipped with firefighting system-related equipment required for fire
              suppression
            </p>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="img">
            <img src="/img/dc/sejong/gallery-slide-21.jpg" />
          </div>
          <div class="txt">
            <p>Mechanical room designed with the structure and size optimized for large-scale data centers</p>
          </div>
        </div>
      </SliderTumbs>
      <article class="bottom">
        <GridBase b50>
          <TextBlock file="dc/sejong-data-t5" class="q pre-line" />
        </GridBase>
        <quick-link>
          <quick-link-item
            ><router-link to="gak-chuncheon"
              >GAK<br class="hidden-md-up" />
              Chuncheon</router-link
            ></quick-link-item
          >
          <quick-link-item type="gray"
            ><a class="launch" target="_blank" href="https://datacenter.ncloud.com/"
              >GAK<br class="hidden-md-up" />
              Chuncheon<br />Virtual tour</a
            ></quick-link-item
          >
        </quick-link>
      </article>
    </div>
  </GridBase>
</template>

<script>
import GridBase from "@/views/components/GridBase";
import PrSplit from "@/views/components/PrSplit";
import TextBlock from "@/views/components/TextBlock";
import PrHoldOrNot from "@/views/components/PrHoldOrNot";
import PrBlock from "@/views/components/PrBlock";
import feature from "@/data/gak/chuncheonFeature";
import QuickLink from "@/views/components/QuickLink";
import QuickLinkItem from "@/views/components/QuickLinkItem";
import Slider from "@/views/components/Slider";
import SliderTumbs from "@/views/components/SliderTumbs";
import PrSlideOrNot from "@/views/components/PrSlideOrNot";

import { getOffsetLeft } from "@/utils";

export default {
  name: "gak-common",
  components: {
    Slider,
    SliderTumbs,
    QuickLinkItem,
    QuickLink,
    PrBlock,
    PrHoldOrNot,
    TextBlock,
    PrSplit,
    GridBase,
    PrSlideOrNot,
  },
  data() {
    return {
      f2Active: -1,
      f3Active: -1,
      feature,
      f1: feature[0],
      f2: feature[1],
      f3: feature[2],
      buildingT1: `Nature-like<br />buildings`,
      galleryT1: `Photo title`,
    };
  },
  watch: {},
  computed: {
    chuncheonPopupStatus() {
      return this.$store.state.chuncheonPopup;
    },
  },
  methods: {
    showPopupF1(idx) {
      this.$store.commit("setChuncheonPopup", {
        type: "type-01",
        idx,
        info: this.f1,
      });
    },
    showPopupF2(idx) {
      this.$store.commit("setChuncheonPopup", {
        type: "type-02",
        idx,
        info: this.f2,
      });
    },
    resetF2(idx, el) {
      this.f2Active = idx;
      const right = getOffsetLeft(el) + +el.parentNode.style.transform.match(/(-?\d+)px/)[1] + el.offsetWidth;
      if (right > window.innerWidth) this.$refs.f2slide.next();
    },
    resetF3(idx) {
      if (this.sect === "sm" || this.sect === "md") {
        this.$store.commit("setChuncheonPopup", {
          type: "type-03",
          idx,
          info: this.f3,
        });
      } else {
        this.f3Active = this.f3Active === idx ? null : idx;
      }
    },
    closePopup() {
      this.$store.commit("setChuncheonPopup", null);
    },
    resize() {
      this.closePopup();
    },
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
};
</script>
